import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetClientState, getClient } from "../../../../store/client/action";
import { getVillage, resetVillageState } from "../../../../store/village/action";
import { resetCompanyState, getCompany } from "../../../../store/company/action";
import { getDealStatus as onGetDealStatuss, addNewDealStatus as onAddNewDealStatus, updateDealStatus as onUpdateDealStatus, deleteDealStatus as onDeleteDealStatus, getDealStatusLoading } from "../../../../store/dealStatus/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../../../Components/Common/ExportCSVModal";

const DealStatus = () => {
    const [modal, setModal] = useState(false);
    const [activeTab, setActiveTab] = useState("1");

    const dispatch = useDispatch();

    const { clients, clientLoading, companies, companyLoading, dealStatus, isDealStatusCreated, isDealStatusSuccess, loading, error, dealStatusLoading, villages, villageLoading } = useSelector((state) => ({
        dealStatus: state.DealStatus.dealStatus,
        loading: state.DealStatus.loading,
        dealStatusLoading: state.DealStatus.loading,
        isDealStatusCreated: state.DealStatus.isDealStatusCreated,
        isDealStatusSuccess: state.DealStatus.isDealStatusSuccess,
        error: state.DealStatus.error,
        companies: state.Company.companies,
        companyLoading: state.Company.loading,
        clients: state.Client.clients,
        clientLoading: state.Client.loading,
    }));

    const [dealStat, setDealStatus] = useState([]);
    const [isExportCSV, setIsExportCSV] = useState(false);
    const [statusActive, setStatusActive] = useState([]);
    const [parentList, setParentList] = useState([]);
    const [dealStatusList, setDealStatusList] = useState([]);
    const [dealStatusName, setDealStatusName] = useState({});
    const [villageList, setVillageList] = useState([]);
    const [clientList, setClientList] = useState([]);
    const [companyList, setCompanyList] = useState([]);

    const statusActiveData = [
        {
            options: [
                { label: "DRAFT", value: "1" },
                { label: "ACTIVE", value: "2" },
                { label: "INACTIVE", value: "3" },
            ],
        },
    ];

    const [isSearch, setIsSearch] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteModalMulti, setDeleteModalMulti] = useState(false);
    const [userRole, setRoles] = useState(null);
    const [userType, setUserType] = useState("user");
    const [userData, setUserData] = useState(null);
    const [isDisabledUserType, setIsDisabledUserType] = useState(false);
    const [clientId, setClientId] = useState(0);

    const onClickDelete = (dealStatus) => {
        setDealStatus(dealStat);
        setDeleteModal(true);
    };

    const handleDeleteDealStatus = () => {
        if (dealStat) {
            dispatch(onDeleteDealStatus(dealStat));
            setDeleteModal(false);
        }
    };

    useEffect(() => {
        setIsLoading(loading);
    }, [loading]);

    useEffect(() => {
        if (!isEmpty(dealStatus)) {
            let arr = [];
            dealStatus.forEach((element) => {
                arr.push({ value: element.id, label: element.dealStatus_name });
            });
            setParentList(arr);
        }
    }, [dealStatus]);

    const toggleTab = (tab, type) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
            let filteredDealStatuss = dealStatus;
            if (type !== "all") {
                filteredDealStatuss = dealStatus.filter((dealStatus) => dealStatus.status_deal_status.name === type);
            }
            setDealStatusList(filteredDealStatuss);
        }
    };

    useEffect(() => {
        if (!isSearch) {
            dispatch(onGetDealStatuss());
        }
        setIsSearch(true);
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setClientId(obj.data.clientId);
        if (obj?.data) {
            setUserData(obj.data);
            if (obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method) {
                setRoles(obj?.data?.user?.user_position?.position_role.method);
            }
        } else setRoles(null);

        if (obj.data && obj?.data?.userType) setUserType(obj?.data?.userType);
    }, [dispatch, dealStatus, isSearch]);

    // useEffect(() => {
    //   if (companies && !companies.length) {
    //     dispatch(resetCompanyState());
    //     dispatch(getCompany({ clientId: clientId }));
    //   }
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [dispatch, companies]);

    // useEffect(() => {
    //   if (!isEmpty(companies)) {
    //     var data = [];
    //     var opt = [];
    //     (companies || []).forEach((item, key) => {
    //       const name = item.name;
    //       const id = item.id;
    //       var obj = { label: name, value: id };
    //       opt.push(obj);
    //     });
    //     var option = { options: opt };
    //     data.push(option);
    //     setCompanyList(data);
    //   }
    // }, [companies]);
    useEffect(() => {
        if (!isEmpty(clients)) {
            var data = [];
            var opt = [];
            clients.forEach((item, key) => {
                const name = item.name;
                const id = item.id;
                var obj = { label: name, value: id };
                opt.push(obj);
            });
            var option = { options: opt };
            data.push(option);
            setClientList(data);
        }
    }, [clients]);

    useEffect(() => {
        var data = [];
        var opt = [];
        (companies || []).forEach((item, key) => {
            const name = item.name;
            const id = item.id;
            var obj = { label: name, value: id };
            opt.push(obj);
        });
        var option = { options: opt };
        data.push(option);

        if (companies.length > 0) {
            setCompanyList(data);
        }
    }, [companies]);

    function handleDealStatus(e) {
        if (e.length > 2) {
            const param = { title: e, status: 2 };
            dispatch(onGetDealStatuss(param));
        }
        return false;
    }

    useEffect(() => {
        if (!isEmpty(dealStatus)) {
            var data = [];
            var opt = [];
            dealStatus.forEach((item, key) => {
                const dealStatus_name = item.dealStatus_name;
                const id = item.id;
                var obj = { label: dealStatus_name, value: id };
                opt.push(obj);
            });
            var option = { options: opt };
            data.push(option);
            setDealStatusList(data);
        }
    }, [dealStatus]);

    useEffect(() => {
        setDealStatus(dealStatus);
    }, [dealStatus]);

    useEffect(() => {
        if (!isEmpty(dealStatus)) {
            setDealStatus(dealStatus);
            setIsEdit(false);
        }
    }, [dealStatus]);

    useEffect(() => {
        if (!isEmpty(dealStatus)) setDealStatusList(dealStatus);
    }, [dealStatus]);

    const toggle = useCallback(() => {
        if (modal) {
            setModal(false);
            setClientList([]);
            setCompanyList([]);
            dispatch(resetCompanyState());
            dispatch(resetClientState());
            validation.resetForm();
            validation.setErrors({});
            setIsDisabledUserType(false);
        } else {
            setModal(true);
            dispatch(getClient());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modal]);

    const handleDealStatusClick = useCallback(
        (arg) => {
            const dealStat = arg;
            setDealStatus({
                id: dealStat.id,
                sortOrder: dealStat.sort_order,
                name: dealStat.name,
                description: dealStat.description,
                client:
                    dealStat.status_deal_client && {
                        label: dealStat.status_deal_client ? dealStat.status_deal_client.name : "",
                        value: dealStat.status_deal_client ? dealStat.status_deal_client.id : "",
                    },
                company:
                    dealStat.status_deal_company && {
                        label: dealStat.status_deal_company ? dealStat.status_deal_company.name : "",
                        value: dealStat.status_deal_company ? dealStat.status_deal_company.id : "",
                    },
                status: dealStat.status_deal_status === null
                    ? ""
                    : {
                        label: dealStat.status_deal_status.name ?? "",
                        value: dealStat.status_deal_status.id ?? "",
                    },
            });

            switch (userType) {
                case "admin":
                    setIsDisabledUserType(false);
                    break;

                default:
                    setIsDisabledUserType(true);
                    break;
            }

            setIsEdit(true);
            toggle();
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [toggle, userType]
    );

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            name: (dealStat && dealStat.name) ?? "",
            status: (dealStat && dealStat.status) || "1",
            description: (dealStat && dealStat.description) ?? "",
            client: (dealStat && dealStat.client) ?? "",
            company: (dealStat && dealStat.company) ?? "",
            sortOrder: (dealStat && dealStat.sortOrder) ?? "",
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Please Enter DealStatus Name").nullable(true),
            sortOrder: Yup.string().required("Please Enter Short Order").nullable(true),
            status: Yup.object().required("Please Select Status"),
        }),
        onSubmit: (values) => {
            dispatch(getDealStatusLoading());
            if (isEdit) {
                const updateDealStatus = {
                    id: dealStat ? dealStat.id : 0,
                    name: values.name,
                    description: values.description,
                    statusId: values.status.value,
                    clientId: values.client.value,
                    companyId: values.company.value,
                    sort_order: values.sortOrder,
                };
                dispatch(onUpdateDealStatus(updateDealStatus));
                validation.resetForm();
            } else {
                const newDealStatus = {
                    name: values.name,
                    description: values.description,
                    statusId: values.status.value,
                    clientId: values.client.value,
                    companyId: values.company.value,
                    sort_order: values.sortOrder,
                };
                dispatch(onAddNewDealStatus(newDealStatus));
                validation.resetForm();
            }
            toggle();
        },
    });

    const checkedAll = () => {
        const checkall = document.getElementById("checkBoxAll");
        const ele = document.querySelectorAll(".dataCheckbox");

        if (checkall.checked) {
            ele.forEach((ele) => {
                ele.checked = true;
            });
        } else {
            ele.forEach((ele) => {
                ele.checked = false;
            });
        }
    };

    // Delete Multiple
    const deleteMultiple = () => {
        const ele = document.querySelectorAll(".dataCheckbox:checked");
        const checkall = document.getElementById("checkBoxAll");
        ele.forEach((element) => {
            dispatch(onDeleteDealStatus(element.value));
        });
        checkall.checked = false;
    };

    // Column
    const columns = useMemo(
        () => [
            {
                Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
                Cell: (cellProps) => {
                    return <input type="checkbox" className="dataCheckbox form-check-input" value={cellProps.row.original.id} />;
                },
                id: "#",
            },
            {
                Header: " ",
                filterable: false,
                Cell: (cellProps) => {
                    return (
                        <div className="hstack gap-2 mt-4 mt-sm-0">
                            <Link
                                to="#"
                                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-icon btn btn-sm btn-light edit-item-btn" : userRole && userRole.split(",").indexOf("updateDealStatus") !== -1 ? "btn-icon btn btn-sm btn-light edit-item-btn" : "btn-icon btn btn-sm btn-light edit-item-btn d-none"}
                                onClick={() => {
                                    const dealStatusData = cellProps.row.original;
                                    handleDealStatusClick(dealStatusData);
                                }}>
                                <i className="ri-edit-2-line fs-15"></i>
                            </Link>
                            <Link
                                to="#"
                                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : userRole && userRole.split(",").indexOf("deleteDealStatus") !== -1 ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : "btn-icon btn btn-sm btn-soft-danger remove-item-btn d-none"}
                                onClick={() => {
                                    const dealStatusData = cellProps.row.original;
                                    onClickDelete(dealStatusData);
                                }}>
                                <i className="ri-delete-bin-line fs-15 text-danger"></i>
                            </Link>
                        </div>
                    );
                },
            },
            {
                Header: "DealStatus",
                accessor: "name",
                filterable: true,
            },
            {
                Header: "Grup Usaha",
                accessor: "status_deal_client.name",
                filterable: true,
            },
            {
                Header: "Sort Order",
                accessor: "sort_order",
                filterable: true,
            },
            {
                Header: "Keterangan",
                accessor: "description",
                filterable: true,
            },
            {
                Header: "Status",
                accessor: "status_deal_status.name",
                filterable: true,
                Cell: (cell) => {
                    switch (cell.value) {
                        case "DRAFT":
                            return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
                        case "ACTIVE":
                            return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
                        case "INACTIVE":
                            return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
                        default:
                            return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
                    }
                },
            },
        ],
        [handleDealStatusClick, userType, userRole]
    );

    const defaultdate = () => {
        return moment(new Date()).format("YYYY/MM/DD HH:mm:ss").toString();
    };

    const [filterDate, setFilterDate] = useState(null);

    const handleValidDate = (date) => {
        return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
    };

    const handleValidTime = (time) => {
        return moment(new Date(time), "YYYY/MM/DD").format("HH:mm");
    };

    //TABLE
    const {
        getTableProps, rows,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        canPreviousPage,
        canNextPage,
        pageOptions,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        preGlobalFilteredRows,
        setGlobalFilter,
        state: { pageIndex, pageSize },
    } = useTable(
        {
            columns: columns,
            data: dealStatusList,
            defaultColumn: { Filter: null },
            initialState: {
                pageIndex: 0,
                pageSize: 10,
                selectedRowIds: 0,
            },
        },
        useGlobalFilter,
        useFilters,
        useSortBy,
        useExpanded,
        usePagination,
        useRowSelect
    );

    const generateSortingIndicator = (column) => {
        return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
    };

    const generateFilterable = (column) => {
        return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
    };

    const onChangeInSelect = (event) => {
        setPageSize(Number(event.target.value));
    };

    const onChangeInInput = (event) => {
        const page = event.target.value ? Number(event.target.value) - 1 : 0;
        gotoPage(page);
    };

    const count = preGlobalFilteredRows.length;
    const [searchValue, setSearchValue] = useState([]);
    const onChange = useAsyncDebounce((value) => {
        setGlobalFilter(value || undefined);
    }, 200);

    function handleDealStatusStatus(data) {
        setStatusActive(data);
    }

    function handleFilter() {
        let startat = "";
        let endat = "";
        let datearr = filterDate?.split(" to ");
        if (datearr[1]) {
            startat = datearr[0];
            endat = datearr[1] ? datearr[1] : datearr[0];
        }
        var status = statusActive.value ? statusActive.value : "";
        const param = {
            title: searchValue,
            startat: startat,
            endat: endat,
            status: status,
        };
        dispatch(onGetDealStatuss(param));
    }

    const handleGetDepartementByDealStatus = (dealStatusId) => {
        dispatch(onGetDealStatuss({ dealStatusId: dealStatusId }));
    };

    const promiseOptions = (e) => {
        if (!villageLoading) {
            dispatch(resetVillageState());
            setVillageList([]);
            if (e.length > 3) {
                dispatch(getVillage({ title: e }));
            }
            return new Promise((resolve, reject) => {
                while (villageLoading);
                resolve(villageList);
            });
        }
    };

    function handleCompany(e) {
        if (e.length > 2) {
            const param = { title: e, status: 2 };
            dispatch(getCompany(param));
        }
        return false;
    }

    const handleGetCompany = (id) => {
        dispatch(resetCompanyState());
        dispatch(getCompany({ clientId: id }));
    };

    const setInputType = (type) => {
        if (userData) {
            switch (type) {
                case "user":
                    setDealStatus({
                        client:
                            userData.clientId === null
                                ? ""
                                : {
                                    label: userData.client_name ? userData.client_name : "",
                                    value: userData.clientId ? userData.clientId : "",
                                },
                        company:
                            userData.companyId === null
                                ? ""
                                : {
                                    label: userData.company_name ? userData.company_name : "",
                                    value: userData.companyId ? userData.companyId : "",
                                },
                    });
                    setIsDisabledUserType(true);
                    break;
                case "client":
                    setDealStatus({
                        client:
                            userData.clientId === null
                                ? ""
                                : {
                                    label: userData.client_name ? userData.client_name : "",
                                    value: userData.clientId ? userData.clientId : "",
                                },
                    });
                    handleGetCompany(userData.clientId);
                    setIsDisabledUserType(true);
                    break;
                case "company":
                    setDealStatus({
                        client:
                            userData.clientId === null
                                ? ""
                                : {
                                    label: userData.client_name ? userData.client_name : "",
                                    value: userData.clientId ? userData.clientId : "",
                                },
                        company:
                            userData.companyId === null
                                ? ""
                                : {
                                    label: userData.company_name ? userData.company_name : "",
                                    value: userData.companyId ? userData.companyId : "",
                                },
                    });
                    setIsDisabledUserType(true);
                    break;

                default:
                    setDealStatus("");
                    setIsDisabledUserType(false);
                    break;
            }
        }
    };

    document.title = "Deal Status | Enterprise Resources Planning";
    return (
        <div className="page-content">
            <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={dealStatusList} />
            <DeleteModal show={deleteModal} onDeleteClick={handleDeleteDealStatus} onCloseClick={() => setDeleteModal(false)} />
            <DeleteModal
                show={deleteModalMulti}
                onDeleteClick={() => {
                    deleteMultiple();
                    setDeleteModalMulti(false);
                }}
                onCloseClick={() => setDeleteModalMulti(false)}
            />
            <Container fluid>
                <BreadCrumb title="Deal Status" pageTitle="Penugasan" />
                <Row>
                    <Col lg={12}>
                        <Card id="dealStatusList">
                            <CardHeader className="card-header border-0">
                                <div className="d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1">
                                        Deal Status History &nbsp;
                                        {isLoading ? (
                                            <>
                                                <Spinner color="primary" type="grow" size={"sm"}>
                                                    Loading...
                                                </Spinner>
                                                &nbsp;
                                                <Spinner color="success" type="grow" size={"sm"}>
                                                    Loading...
                                                </Spinner>
                                                &nbsp;
                                            </>
                                        ) : (
                                            ""
                                        )}
                                    </h5>
                                    <div className="flex-shrink-0">
                                        <button
                                            type="button"
                                            className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createDealStatus") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
                                            id="create-btn"
                                            onClick={() => {
                                                setInputType(userType);
                                                setIsEdit(false);
                                                toggle();
                                            }}>
                                            <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
                                        </button>                <button type="button" className="btn btn-success me-1" onClick={() => setIsExportCSV(true)}>
                                            <i className="ri-file-download-line me-1 align-bottom fs-14"></i> Export
                                        </button>                <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteDealStatus") !== -1 ? "btn btn-soft-danger" : "btn btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
                                            <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
                                        </button>
                                    </div>
                                </div>
                            </CardHeader>
                            <CardBody className="pt-0">
                                <div>
                                    <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                                                onClick={() => {
                                                    toggleTab("1", "all");
                                                }}
                                                href="#"
                                            >
                                                <i className="ri-booklet-line me-1 align-bottom fs-14"></i> ALL STATUS
                                            </NavLink>
                                        </NavItem>

                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                                                onClick={() => {
                                                    toggleTab("2", "DRAFT");
                                                }}
                                                href="#">
                                                <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> DRAFT</NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                                                onClick={() => {
                                                    toggleTab("3", "Active");
                                                }}
                                                href="#"
                                            >
                                                <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE                    </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                                                onClick={() => {
                                                    toggleTab("4", "Inactive");
                                                }}
                                                href="#"
                                            >
                                                <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> INACTIVE</NavLink>
                                        </NavItem>
                                    </Nav>
                                    <Row className="mb-3">
                                        <CardBody className="border border-top-0 border-end-0 border-start-0">
                                            <form>
                                                <Row>
                                                    <Col sm={2}>
                                                        <div className="me-2 mb-2 col-12">
                                                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                                                    <option key={pageSize} value={pageSize}>
                                                                        {pageSize}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <div className="search-box me-2 mb-2 d-inline-block col-12">
                                                            <input
                                                                onChange={(e) => {
                                                                    setSearchValue(e.target.value);
                                                                    onChange(e.target.value);
                                                                    gotoPage(0);
                                                                }}
                                                                id="search-bar-0"
                                                                type="text"
                                                                className="form-control search"
                                                                placeholder={`${count} Search...`}
                                                                value={searchValue ?? ""}
                                                            />
                                                            <i className="bx bx-search-alt search-icon"></i>
                                                        </div>
                                                    </Col>
                                                    <Col sm={6} className="col-xxl-3">
                                                        <div className="search-box mb-2">
                                                            <Flatpickr
                                                                className="form-control"
                                                                id="datepicker-publish-input"
                                                                placeholder="Select created date"
                                                                options={{
                                                                    mode: "range",
                                                                    dateFormat: "Y/m/d",
                                                                }}
                                                                onChange={(selectedDates, dateStr) => {
                                                                    setFilterDate(dateStr);
                                                                }}
                                                            />
                                                            <i className="bx bx-calendar-alt search-icon"></i>
                                                        </div>
                                                    </Col>

                                                    <Col sm={4} className="col-xxl-2">
                                                        <div className="me-2 mb-2 col-12">
                                                            <Select
                                                                value={statusActive}
                                                                placeholder="Select Status"
                                                                onChange={(e) => {
                                                                    handleDealStatusStatus(e);
                                                                }}
                                                                options={statusActiveData}
                                                                name="choices-single-default"
                                                            ></Select>
                                                        </div>
                                                    </Col>

                                                    <Col sm={2}>
                                                        <div>
                                                            <button
                                                                type="button"
                                                                className="btn btn-light w-100"
                                                                onClick={() => {
                                                                    handleFilter();
                                                                }}
                                                            >
                                                                <i className="ri-search-line me-1 align-bottom fs-14"></i>
                                                            </button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </form>
                                        </CardBody>
                                    </Row>
                                    <div className="table-responsive table-card mb-1">
                                        <Table hover {...getTableProps()} className="align-middle table-nowrap">
                                            <thead className="table-light">
                                                {headerGroups.map((headerGroup, index) => (
                                                    <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                                                        {headerGroup.headers.map((column, index) => (
                                                            <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                                                {column.render("Header")}
                                                                {generateSortingIndicator(column)}
                                                                {/* <Filter column={column} /> */}
                                                            </th>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </thead>

                                            <tbody {...getTableBodyProps()}>
                                                {page.map((row) => {
                                                    prepareRow(row);
                                                    return (
                                                        <Fragment key={row.getRowProps().key}>
                                                            <tr>
                                                                {row.cells.map((cell, index) => {
                                                                    return (
                                                                        <td {...cell.getCellProps()} key={index}>
                                                                            {cell.render("Cell")}
                                                                        </td>
                                                                    );
                                                                })}
                                                            </tr>
                                                        </Fragment>
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>

                                    <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                                        <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                                        <Col className="col-md-auto">
                                            <div className="d-flex gap-1">
                                                <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                                                    {"<"}                        </Button>
                                            </div>
                                        </Col>
                                        <Col className="col-md-auto d-none d-md-block">
                                            Page                    <strong>
                                                {pageIndex + 1} of {pageOptions.length}
                                            </strong>
                                        </Col>
                                        <Col className="col-md-auto">
                                            <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                                        </Col>
                                        <Col className="col-md-auto">
                                            <div className="d-flex gap-1">
                                                <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                                                    {">"}
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <Modal id="showModal" isOpen={modal} centered size="md">
                                    <ModalHeader className="bg-light p-3" toggle={toggle}>
                                        {!!isEdit ? "Edit Deal Status" : "Tambah Deal Status"}
                                    </ModalHeader>
                                    <Form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            validation.handleSubmit();
                                            return false;
                                        }}>
                                        <ModalBody>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="mb-3">
                                                        <Label htmlFor="client-field" className="form-label">
                                                            Grup Usaha&nbsp;
                                                            {clientLoading ? (
                                                                <Spinner color="primary" size="sm">
                                                                    Loading...
                                                                </Spinner>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </Label>
                                                        <Select
                                                            name="client"
                                                            value={validation.values.client}
                                                            isDisabled={isDisabledUserType}
                                                            placeholder="Pilih Grup Usaha"
                                                            onChange={(e) => {
                                                                setCompanyList([]);
                                                                validation.setFieldValue("company", "");
                                                                validation.setFieldValue("client", e);
                                                                handleGetCompany(e.value);
                                                            }}
                                                            options={clientList}
                                                        ></Select>
                                                        {validation.touched.client && validation.errors.client ? (
                                                            <small className="text-danger" type="invalid">
                                                                {validation.errors.client}
                                                            </small>
                                                        ) : null}
                                                    </div>

                                                    <div className="mb-3">
                                                        <Label htmlFor="company-field" className="form-label">
                                                            Perusahaan&nbsp;
                                                            {companyLoading ? (
                                                                <Spinner color="primary" size="sm">
                                                                    Loading...
                                                                </Spinner>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </Label>
                                                        <Select
                                                            name="company"
                                                            value={validation.values.company}
                                                            placeholder="Pilih Perusahaan"
                                                            isDisabled={companyList.length > 0 ? false : true}
                                                            onChange={(e) => {
                                                                validation.setFieldValue("company", e);
                                                            }}
                                                            options={companyList}
                                                        ></Select>
                                                        {validation.touched.company && validation.errors.company ? (
                                                            <small className="text-danger" type="invalid">
                                                                {validation.errors.company}
                                                            </small>
                                                        ) : null}
                                                    </div>
                                                    <div className="mb-3">
                                                        <Label htmlFor="sortOrder-field" className="form-label">
                                                            Short Order                                </Label>
                                                        <Input name="sortOrder" id="name-field" className="form-control" placeholder="Enter Short Order" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.sortOrder ?? ""} invalid={validation.touched.sortOrder && validation.errors.sortOrder ? true : false} />
                                                        {validation.touched.sortOrder && validation.errors.sortOrder ? <FormFeedback type="invalid">{validation.errors.sortOrder}</FormFeedback> : null}
                                                    </div>
                                                    <div className="mb-3">
                                                        <Label htmlFor="name-field" className="form-label">
                                                            Nama                                </Label>
                                                        <Input name="name" id="name-field" className="form-control" placeholder="Enter Nama" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                                                        {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                                                    </div>

                                                    <div className="mb-3">
                                                        <Label htmlFor="status-field" className="form-label">
                                                            Status
                                                        </Label>
                                                        <Select
                                                            name="status"
                                                            value={validation.values.status}
                                                            validate={{ required: { value: true } }}
                                                            placeholder="Select Status"
                                                            onChange={(e) => {
                                                                validation.setFieldValue("status", e);
                                                            }}
                                                            onInputChange={(e) => {
                                                                // handleUnit(e);
                                                            }}
                                                            options={statusActiveData}
                                                            invalid={validation.touched.status && validation.errors.status ? true : false}
                                                        ></Select>
                                                        {validation.touched.status && validation.errors.status ? (
                                                            <p className="text-danger" type="invalid">
                                                                {validation.errors.status}
                                                            </p>
                                                        ) : null}
                                                    </div>
                                                    <div className="mb-3">
                                                        <Label htmlFor="des-field" className="form-label">
                                                            Keterangan
                                                        </Label>
                                                        <Input name="description" id="des-field" className="form-control" rows={6} placeholder="Enter Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                                                    </div>
                                                </div>
                                            </div>
                                        </ModalBody>
                                        <div className="modal-footer">
                                            <div className="hstack gap-2 justify-content-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-light"
                                                    onClick={() => {
                                                        setModal(false);
                                                        dispatch(onGetDealStatuss({ status: 1 }));
                                                        validation.resetForm();
                                                    }}
                                                >
                                                    Close                        </button>
                                                <button type="submit" className="btn btn-success">
                                                    <span className="d-flex align-items-center">
                                                        <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Tambah Deal Status"}</span>
                                                        {loading ? (
                                                            <Spinner size="sm" className="flex-shrink-0" role="status">
                                                                Loading...
                                                            </Spinner>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </Form>
                                </Modal>

                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default DealStatus;
